module.exports = ".badge-count {\n  height: 41%;\n  position: absolute;\n  top: 13px;\n  right: 1px;\n  text-align: center;\n  border-radius: 17%;\n  background: #f44336;\n  color: var(--white);\n  width: 13%;\n  margin-right: 1em; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/menu/menu.component.scss
// module id = ./src/app/core/menu/menu.component.scss
// module chunks = main